export const divisionKeys = {
	divisionSponsors: (organizationUuid: string, divisionUuid: string) => [`DIVISION_SPONSORS`, organizationUuid, divisionUuid] as const,
	leagueDivisions: (organizationUuid: string, teamLeagueUuid: string, serializedSearchParams: string) =>
		['DIVISIONS', organizationUuid, teamLeagueUuid, serializedSearchParams] as const,
	divisionOptions: (organizationUuid: string, teamLeagueUuid: string) => [`DIVISIONS_OPTIONS`, organizationUuid, teamLeagueUuid] as const
};
